import gql from 'graphql-tag';

export const SURVEY_BY_ID_NEW_OPTIMIZED = gql`
  query SurveyByIdNewOptimized($id: ID!) {
  SurveyById(id: $id) {
    id
    name
    description
    termsConditions
    shuffle
    public
    activeFrom
    activeTo
    reportQuery
    multisourceResponse
    groupSet {
      edges {
        cursor
        node {
          id
          name
          label
          helpText
          sequence
          matrix
          showInResult
          showAvgInResult
          questionSet {
            edges {
              cursor
              node {
                id
                questionText
                required
                helpText
                sequence
                questionAddress
                required
                url
                mediaType
                choiceSet {
                  edges {
                    cursor
                    node {
                      id
                      label
                      value
                      sequence
                      inputType
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
